<template>
  <div>
    <v-row>
      <v-col cols="auto" class="pr-3">
        <BaseButton
          color="whiteSmoke"
          width="14"
          height="30"
          icon
          @click="previousStep"
        >
          <v-icon color="primary" size="14"> fa-chevron-left </v-icon>
        </BaseButton>
      </v-col>
      <v-col cols="10">
        <p class="gray--text" style="margin-top: 2px;">
          VOLTAR
        </p>
      </v-col>
      <v-col cols="10">
        <p class="gray--text font-weight-bold quotation-title">
          PRAZOS
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <BaseFormInput
          id-element="cpfInsuredQuotation"
          placeholder="DD/MM/AAAA"
          v-model="form.date"
          required
          :rules="[requiredInput, dateTermValid]"
          validate-on-blur
          v-facade="maskDate"
          label-text="Início de Vigência"
          disabled
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="pr-sm-5"
        v-if="disabledSliderDeadlineQuotation"
      >
        <BaseFormInput
          id-element="cpfInsuredQuotation"
          placeholder="DD/MM/AAAA"
          v-model="form.date_end"
          required
          :rules="[requiredInput, dateTermValid, greaterThanStartDate]"
          validate-on-blur
          v-facade="maskDate"
          label-text="Fim de Vigência"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pb-9" v-else>
        <v-row>
          <v-col cols="12">
            <label for="sliderQuotation" class="button gray--text mb-2">
              Prazo (em anos)
            </label>
          </v-col>
          <v-col :cols="sizeSliderCols">
            <v-slider
              id="sliderQuotation"
              :tick-labels="labelSlider"
              v-model="form.prazo"
              :min="minRange"
              :max="maxRange"
              track-color="lightGray"
              color="secondary"
              tick-size="3"
              step="1"
              ticks="always"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5 pb-5 pb-sm-0">
        <div class="deadline__validity-col py-5 px-4">
          <p class="button primary--text mb-0">
            Início de vigência:
          </p>
          <p class="font-weight-bold button primary--text mb-0">
            DE 24HRS DE {{ startTerm }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5 pb-5 pb-md-0">
        <div class="deadline__validity-col py-5 px-4">
          <p class="button primary--text mb-0">
            Término de vigência:
          </p>
          <p class="font-weight-bold primary--text mb-0">
            DE 24HRS DE {{ endTerm }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pb-5 pb-sm-0 pr-sm-5 pr-md-0">
        <div class="deadline__validity-col py-5 px-4">
          <p class="button primary--text mb-0">
            Prazo de vigência:
          </p>
          <p class="font-weight-bold primary--text mb-0">
            {{ intervalTerm }} DIAS
          </p>
        </div>
      </v-col>
      <v-col cols="12" class="pb-7 pt-12">
        <v-divider />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { requiredInput, dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import { mapState } from "vuex";
import { format, addYears, differenceInDays } from "date-fns";
import { parseDateDDMMYYYY } from "@/utils/formats.js";
import _ from "lodash";
export default {
  data: () => ({
    labelSlider: ["3", "4", "5"],
    minRange: 3,
    maxRange: 5,
    requiredInput,
    maskDate,
    startTerm: "DD/MM/AAAA",
    endTerm: "DD/MM/AAAA",
    dateTermValid,
    intervalTerm: 0,
    parseDateDDMMYYYY
  }),
  mounted() {
    this.updateValues();
    this.updateIntervalDate();
  },
  computed: {
    ...mapState("quotation", ["listDeadlineByTaker"]),
    disabledSliderDeadlineQuotation() {
      return this.optionsQuotation.fim_vigencia.obrigatorio;
    },
    sizeSliderCols() {
      return this.maxRange === this.minRange ? "1" : "12";
    }
  },
  methods: {
    previousStep() {
      this.$emit("return");
    },
    updateValues() {
      this.minRange = _.head(this.listDeadlineByTaker).anos;
      this.maxRange = _.last(this.listDeadlineByTaker).anos;
      this.labelSlider = this.listDeadlineByTaker.map(item => item.anos);
    },
    updateIntervalDate() {
      // Trocar valores apenas quando a data
      // estiver no formato correto
      if (this.form.prazo && !this.disabledSliderDeadlineQuotation) {
        const date_start = this.parseDateDDMMYYYY(this.form.date);
        // clonar
        this.startTerm = this.form.date + "";
        let endDate = addYears(date_start, this.form.prazo);
        this.endTerm = format(endDate, "dd/MM/yyyy");
        this.intervalTerm = differenceInDays(endDate, date_start);
      } else if (this.form.date_end && this.disabledSliderDeadlineQuotation) {
        const date_end = this.parseDateDDMMYYYY(this.form.date_end);
        const date_start = this.parseDateDDMMYYYY(this.form.date);
        this.startTerm = this.form.date + "";
        this.endTerm = this.form.date_end + "";
        this.intervalTerm = differenceInDays(date_end, date_start);
      }
    },
    greaterThanStartDate(value) {
      if (!value) return true;
      const endDate = this.parseDateDDMMYYYY(this.form.date_end);
      const startDate = this.parseDateDDMMYYYY(this.form.date);
      return (
        endDate > startDate ||
        "Término da vigência deve ser posterior ao início"
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    }
  },
  watch: {
    "form.date"() {
      this.updateIntervalDate();
    },
    "form.prazo"() {
      this.updateIntervalDate();
    },
    "form.date_end"(value) {
      this.dateTermValid(value) != "Data inválida" && this.updateIntervalDate();
    }
  }
};
</script>
<style lang="sass">
.deadline__
  &validity-col
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #F0F0F7
  &text
    font-size: 14px
</style>
